// 2026-02 — P1 fix: alphabetical client sorting across every dropdown,
// list, and filter that surfaces client groups. Owner spec: A → Z by
// client / company name in New Task, Edit Task, all filters, etc.
// Locale-aware, case-insensitive, with a numeric fallback so "Client 2"
// comes before "Client 10".
export const sortClientsAlpha = (clients = []) => {
  if (!Array.isArray(clients)) return [];
  return [...clients].sort((a, b) =>
    String(a?.name || '').localeCompare(
      String(b?.name || ''),
      undefined,
      { sensitivity: 'base', numeric: true },
    ),
  );
};
